import { render, staticRenderFns } from "./GiftCardAssignTaskTablePane.vue?vue&type=template&id=3325a7ce&scoped=true"
import script from "./GiftCardAssignTaskTablePane.vue?vue&type=script&lang=js"
export * from "./GiftCardAssignTaskTablePane.vue?vue&type=script&lang=js"
import style0 from "./GiftCardAssignTaskTablePane.vue?vue&type=style&index=0&id=3325a7ce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3325a7ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3325a7ce')) {
      api.createRecord('3325a7ce', component.options)
    } else {
      api.reload('3325a7ce', component.options)
    }
    module.hot.accept("./GiftCardAssignTaskTablePane.vue?vue&type=template&id=3325a7ce&scoped=true", function () {
      api.rerender('3325a7ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/gift_card/GiftCardAssignTaskTablePane.vue"
export default component.exports